import dropRight from 'lodash/fp/dropRight';
import flatMap from 'lodash/fp/flatMap';

export const CommaSeparatedList = ({ children }) => {
    const result = dropRight(1, flatMap(item => [item, ', '], children));
    return <span>{result}</span>;
};

export default CommaSeparatedList;
